import React, { useState } from 'react';
import PropTypes from 'prop-types';
import toast from 'react-hot-toast';
import { signUpFlow } from '../hook';
import Modal from '../../Modal';
import styles from '../RegisterForm/SignupForm.module.css';

const SignupForm = () => {
  const [data, setData] = useState({
    name: '',
    email: '',
    password: '',
    confirmPassword: '',
    domain: '',
    phoneNumber: '',
    brandName: '',
    logoUrl: '',
    role: 'admin',
    companyName: '',
    registrationNumber: '',
    registeredCountry: '',
    registeredAddress: '',
    signatoryName: '',
    signatoryDesignation: '',
    bankName: '',
    bankAccountNumber: '',
    companyCurrency: '',
    companyTaxId: ''
  });

  const [privacyPolicyCheck, setPrivacyPolicyCheck] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const [modalText, setModalText] = useState('');
  // const [showVerifyAccessToken, setShowVerifyAccessToken] = useState(false);
  const createAdmin = signUpFlow();

  const handleModalText = (text) => {
    setModalText(text);
  };

  const handleChange = (e) => {
    setData({
      ...data,
      [e.target.name]: e.target.value
    });
  };

  const handleCheckboxChange = () => {
    setPrivacyPolicyCheck((p) => !p);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const {
      name,
      email,
      password,
      domain,
      phoneNumber,
      brandName,
      logoUrl,
      role,
      companyName,
      registrationNumber,
      registeredCountry,
      registeredAddress,
      signatoryName,
      signatoryDesignation,
      bankName,
      bankAccountNumber,
      companyCurrency,
      companyTaxId
    } = data;

    console.log(data);

    if (!privacyPolicyCheck) {
      console.log('policy');
      return;
    }
    if (data.password === data.confirmPassword) {
      console.log(data);
      setShowModal(true);
      createAdmin({
        name,
        email,
        password,
        domain,
        phoneNumber,
        brandName,
        logoUrl,
        role,
        companyName,
        registrationNumber,
        registeredCountry,
        registeredAddress,
        signatoryName,
        signatoryDesignation,
        bankName,
        bankAccountNumber,
        companyCurrency,
        companyTaxId,
        changeModalText: handleModalText,
        setShowModal
        // setShowVerifyAccessToken,
      });
    } else {
      toast.error("password doesn't match!");
      console.log('error');
    }
  };

  const MAX_STEPS = 4;
  const [formStep, setFormStep] = useState(0);
  const completeFormStep = () => {
    setFormStep((cur) => cur + 1);
  };
  const goToPreviousStep = () => {
    setFormStep((cur) => cur - 1);
  };

  const renderButton = () => {
    switch (formStep) {
      case 0:
        return (
          <input
            disabled={data.name === '' || data.email === '' || data.password === '' || data.confirmPassword === ''}
            type="button"
            onClick={completeFormStep}
            value="Next Step"
            id={styles['signup-form__submit']}
          />
        );
      case 1:
        return (
          <>
            <input
              disabled={data.domain === '' || data.phoneNumber === '' || data.brandName === '' || data.logoUrl === ''}
              type="button"
              onClick={completeFormStep}
              value="Next Step"
              id={styles['signup-form__submit']}
            />
            <input type="button" onClick={goToPreviousStep} value="Step Back" id={styles['signup-form__submit']} />
          </>
        );
      case 2:
        return (
          <>
            <input
              disabled={
                data.companyName === '' ||
                data.registrationNumber === '' ||
                data.registeredCountry === '' ||
                data.registeredAddress === '' ||
                data.companyCurrency === '' ||
                data.companyTaxId === ''
              }
              type="button"
              onClick={completeFormStep}
              value="Next Step"
              id={styles['signup-form__submit']}
            />
            <input type="button" onClick={goToPreviousStep} value="Step Back" id={styles['signup-form__submit']} />
          </>
        );
      case 3:
        return (
          <>
            <input
              disabled={
                data.bankName === '' ||
                data.bankAccountNumber === '' ||
                data.signatoryName === '' ||
                data.signatoryDesignation === ''
              }
              type="button"
              onClick={handleSubmit}
              value="Register"
              id={styles['signup-form__submit']}
            />
            <input type="button" onClick={goToPreviousStep} value="Step Back" id={styles['signup-form__submit']} />
          </>
        );
      default:
        return undefined;
    }
  };

  return (
    <form id={styles['signup-form']}>
      <div>
        <p>
          <b>
            {' '}
            Step {formStep + 1} of {MAX_STEPS}{' '}
          </b>
        </p>
      </div>

      {formStep === 0 && (
        <section>
          <input
            required
            title="Enter your full name"
            type="text"
            name="name"
            onChange={handleChange}
            value={data.name}
            placeholder="Full Name"
            className={styles['signup-form__input']}
          />
          <input
            required
            title="Enter your email address" /* Point of Contact Email and Finance Email */
            type="email"
            name="email"
            onChange={handleChange}
            value={data.email}
            placeholder="Email Address"
            className={styles['signup-form__input']}
          />
          <input
            required
            title="8 characters with at least 1 Upper Case, 1 lower case, and 1 numeric character"
            type="password"
            name="password"
            onChange={handleChange}
            value={data.password}
            pattern="^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$"
            placeholder="Password"
            className={styles['signup-form__input']}
          />
          <input
            required
            type="password"
            name="confirmPassword"
            onChange={handleChange}
            value={data.confirmPassword}
            placeholder="Confirm Password"
            className={styles['signup-form__input']}
          />
        </section>
      )}

      {formStep === 1 && (
        <section>
          <input
            required
            type="tel"
            name="phoneNumber"
            onChange={handleChange}
            value={data.phoneNumber}
            placeholder="Phone Number"
            // pattern="[0-9]{10}"
            className={styles['signup-form__input']}
          />
          <input
            required
            title="example: domain.com"
            type="text"
            name="domain"
            onChange={handleChange}
            value={data.domain}
            placeholder="Enter Domain"
            className={styles['signup-form__input']}
          />
          <input
            required
            type="text"
            name="brandName"
            onChange={handleChange}
            value={data.brandName}
            placeholder="Brand Name"
            className={styles['signup-form__input']}
          />
          <input
            required
            type="url"
            title="example: https://www.logo.com"
            name="logoUrl"
            onChange={handleChange}
            value={data.logoUrl}
            placeholder="Enter Logo URL"
            // pattern="^(http|https)://*"
            className={styles['signup-form__input']}
          />
        </section>
      )}

      {formStep === 2 && (
        <section>
          <input
            required
            type="text"
            name="companyName"
            onChange={handleChange}
            value={data.companyName}
            placeholder="Company Name"
            className={styles['signup-form__input']}
          />
          <input
            required
            type="text"
            name="registrationNumber"
            onChange={handleChange}
            value={data.registrationNumber}
            placeholder="Registration Number"
            className={styles['signup-form__input']}
          />
          <input
            required
            type="text"
            name="registeredCountry"
            onChange={handleChange}
            value={data.registeredCountry}
            placeholder="Registered Country"
            className={styles['signup-form__input']}
          />
          <input
            required
            type="text"
            name="registeredAddress"
            onChange={handleChange}
            value={data.registeredAddress}
            placeholder="Registered Address"
            className={styles['signup-form__input']}
          />
          <input
            required
            type="text"
            name="companyCurrency"
            onChange={handleChange}
            value={data.companyCurrency}
            placeholder="Company Currency"
            className={styles['signup-form__input']}
          />
          <input
            required
            type="text"
            name="companyTaxId"
            onChange={handleChange}
            value={data.companyTaxId}
            placeholder="Company Tax Id"
            className={styles['signup-form__input']}
          />
        </section>
      )}

      {formStep === 3 && (
        <section>
          <input
            required
            type="text"
            name="bankName"
            onChange={handleChange}
            value={data.bankName}
            placeholder="Bank Name"
            className={styles['signup-form__input']}
          />
          <input
            required
            type="text"
            name="bankAccountNumber"
            onChange={handleChange}
            value={data.bankAccountNumber}
            placeholder="Bank Account Number"
            className={styles['signup-form__input']}
          />
          <input
            required
            type="text"
            name="signatoryName"
            onChange={handleChange}
            value={data.signatoryName}
            placeholder="Signatory Name"
            className={styles['signup-form__input']}
          />
          <input
            required
            type="text"
            name="signatoryDesignation"
            onChange={handleChange}
            value={data.signatoryDesignation}
            placeholder="Signatory Designation"
            className={styles['signup-form__input']}
          />
          <div className={styles['privacy-policy']}>
            <input
              type="checkbox"
              checked={privacyPolicyCheck}
              onChange={handleCheckboxChange}
              value={privacyPolicyCheck}
            />
            <p>
              I agree to Fewcents{' '}
              <a href="https://fewcents.co/terms" target="_blank" rel="noreferrer">
                Terms
              </a>{' '}
              and{' '}
              <a href="https://fewcents.co/privacy" target="_blank" rel="noreferrer">
                Privacy Policy
              </a>
              . I consent to my data being processed outside EU.
            </p>
          </div>
        </section>
      )}

      {renderButton()}

      {showModal && <RegisterModal setShowModal={setShowModal} text={modalText} />}
    </form>
  );
};

const RegisterModal = ({ setShowModal, text }) => (
  <Modal setShowModal={setShowModal} isLogin>
    <p>{text}</p>
  </Modal>
);

RegisterModal.propTypes = {
  setShowModal: PropTypes.node.isRequired,
  text: PropTypes.node.isRequired
};

export default SignupForm;
